import React, {FC, useState} from 'react';
import styles from './FAQ.module.scss';
import {FAQItem} from '../../../types';
import {cn} from '../../../../../../../utils';

interface FAQProps {
  items: FAQItem[];
  className?: string;
}

const FAQ: FC<FAQProps> = ({items, className}) => {
  const [openItems, setOpenItems] = useState<Set<string>>(new Set());

  const toggleItem = (id: string) => {
    setOpenItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  return (
    <div className={cn(styles.faq, className)}>
      {items.map((item) => {
        const isOpen = openItems.has(item.id);
        
        return (
          <div key={item.id} className={styles.faqItem}>
            <button
              type="button"
              className={styles.faqButton}
              onClick={() => toggleItem(item.id)}
              aria-expanded={isOpen}
            >
              <span className={styles.faqQuestion}>{item.question}</span>
              <span className={cn(styles.faqIcon, isOpen && styles['faqIcon--open'])}>
                +
              </span>
            </button>
            {isOpen && (
              <div className={styles.faqAnswer}>
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQ;

